import { useEffect, useState } from 'react';
import {
    PanelBody,
    Button,
    Modal,
    TextControl,
    SelectControl,
    TextareaControl,
    CheckboxControl,
    RadioControl,
    Spinner,
    __experimentalNumberControl as NumberControl,
    Flex,
    FlexItem,
    FlexBlock,
    FormToggle
} from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import { fetchData, saveData } from './api';
const GeneralTab = ({ openPopup , setActiveTab }) => {
    const [isSaving, setIsSaving] = useState(false);
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState({});
    const [customFields, setCustomFields] = useState([]);
    const [modifiedFields, setModifiedFields] = useState({});
    const [gmwpdl_usershow, setGmwpdl_usershow] = useState([
        { key: 'short_description', label: 'Short Description' },
        { key: 'sku', label: 'SKU' },
        { key: 'weight', label: 'Weight' },
        { key: 'dimen', label: 'Dimension' },
        { key: 'cat', label: 'Categories' },
        { key: 'tag', label: 'Tags' },
        { key: 'attr', label: 'Attributes' },
        { key: 'stock', label: 'Stock' },
    ]);
 
    useEffect(() => {
        // Fetch settings from the REST API
        fetchData(gmwpdl_wp_ajax.getsettings, gmwpdl_wp_ajax.nonce)
            .then((fetchedData) => {
                setData(fetchedData);
                if (fetchedData.gmwpdl_custom_fields) {
                    setCustomFields(fetchedData.gmwpdl_custom_fields);
                }
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
                console.error('Error fetching settings:', error);
            });
    }, []);

    const updateField = (field, value) => {
        setData((prevData) => ({
            ...prevData,
            [field]: value,
        }));
        setModifiedFields((prevFields) => ({
            ...prevFields,
            [field]: value,
        }));
    };
    const toggleCheckbox = (fieldName, key) => {
        setData((prevData) => {
            const currentValues = prevData[fieldName] || [];
            const updatedValues = currentValues.includes(key)
                ? currentValues.filter((item) => item !== key) // Remove key if already present
                : [...currentValues, key]; // Add key if not present
            return {
                ...prevData,
                [fieldName]: updatedValues,
            };
        });
        setModifiedFields((prevFields) => ({
            ...prevFields,
            [fieldName]: data[fieldName]?.includes(key)
                ? data[fieldName].filter((item) => item !== key)
                : [...(data[fieldName] || []), key],
        }));
    };

    const saveSettings = () => {
        if (Object.keys(modifiedFields).length === 0) {
            openPopup('No changes to save.');
            return;
        }
        setIsSaving(true);

        saveData(gmwpdl_wp_ajax.savedata, gmwpdl_wp_ajax.nonce, modifiedFields)
            .then((responseData) => {
                setIsSaving(false);
                if (responseData.success) {
                    openPopup('Settings saved!');
                    setModifiedFields({});
                } else {
                    openPopup('Failed to save settings.');
                }
            })
            .catch((error) => {
                setIsSaving(false);
                console.error('Error saving settings:', error);
               openPopup('Failed to save settings.');
            });
    };
    
    
    return (
        <PanelBody>
             {loading ? (
                <Spinner />
            ) : (
                <>
                        <table className="GMadminTable">
                            <tbody>
                            <tr>
                          
                                <th>
                                    <label>Show/Hide Options</label>
                                </th>
                                <td>
                                   {gmwpdl_usershow.map(({ key, label }) => (
                                        <div
                                            key={key}
                                            
                                          
                                        >
                                            <div>
                                                <CheckboxControl
                                                    label={label}
                                                    checked={data.gmwpdl_usershow?.includes(key)} // Check if key exists in array
                                                    onChange={() => toggleCheckbox('gmwpdl_usershow', key)} // Pass field name and key dynamically
                                                  
                                                />
                                            </div>
                                            
                                        </div>
                                    ))}


                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <label>Product Custom Meta Fields</label>
                                </th>
                                <td>
                                    {customFields.map((field, index) => (
                                        <div key={index} style={{ display: 'flex',gap: '10px',alignItems: 'center', marginBottom: '10px' }}>
                                            <div>
                                                <div>{__('Label', 'text-domain')}</div>
                                            <TextControl
                                                placeholder={__('Enter Label', 'text-domain')}
                                                value={field.label}
                                                onChange={(value) => {
                                                    const newCustomFields = [...customFields];
                                                    newCustomFields[index].label = value;
                                                    setCustomFields(newCustomFields);
                                                    updateField('gmwpdl_custom_fields', newCustomFields);
                                                }}
                                               
                                            />
                                            </div>
                                            <div>
                                                <label>{__('Meta Key', 'text-domain')}</label>
                                            <TextControl
                                                placeholder={__('Enter Meta Key', 'text-domain')}
                                                value={field.value}
                                                onChange={(value) => {
                                                    const newCustomFields = [...customFields];
                                                    newCustomFields[index].value = value;
                                                    setCustomFields(newCustomFields);
                                                    updateField('gmwpdl_custom_fields', newCustomFields);
                                                }}
                                            />
                                            </div>
                                            <Button
                                                isDestructive
                                                onClick={() => {
                                                    const newCustomFields = customFields.filter((_, i) => i !== index);
                                                    setCustomFields(newCustomFields);
                                                    updateField('gmwpdl_custom_fields', newCustomFields);
                                                }}
                                                style={{ marginLeft: '10px' }}
                                            >
                                                {__('Remove', 'text-domain')}
                                            </Button>
                                        </div>
                                    ))}
                                    <Button
                                        variant="secondary"
                                        onClick={() => {
                                            const newCustomFields = [...customFields, { value: '', label: '' }];
                                            setCustomFields(newCustomFields);
                                            updateField('gmwpdl_custom_fields', newCustomFields);
                                        }}
                                    >
                                        {__('Add Custom Field', 'text-domain')}
                                    </Button>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <label>Show On Label</label>
                                </th>
                                <td>
                                    <FormToggle
                                      checked={data.gmwpdl_show_label === '1'}
                                      onChange={() =>
                                            updateField('gmwpdl_show_label', data.gmwpdl_show_label === '1' ? '0' : '1')
                                        }
                                    />
                                </td>
                            </tr>
                            </tbody>
                            
                        </table>
                         <h4>To set a custom location, you need to use the shortcode. <code>[gmwpdl_product_details]</code></h4>
                        <Button isPrimary onClick={saveSettings} disabled={isSaving}>
                            {isSaving ? <Spinner /> : 'Save Settings'}
                        </Button>
                      </>
            )}
        </PanelBody>
    );
};

export default GeneralTab;
